import { LayoutGrid } from "lucide-react";
import { Button } from "@/modern/components/ui/button-shadcn";
import { useCoverage } from "../context/CoverageContext";
import { HubRow } from "./HubRow";

export const HubLandscapeGrid = () => {
  const { filteredHubs, problemHubs, setActiveFilter, setSearchQuery } = useCoverage();

  if (problemHubs.length === 0) {
    return (
      <div className="flex h-full flex-col items-center justify-center gap-4 px-8 text-center">
        <LayoutGrid className="size-6 text-muted-foreground/50" />
        <div className="space-y-1.5">
          <h3 className="text-sm font-semibold text-foreground">No problem hubs yet</h3>
          <p className="text-xs text-muted-foreground">
            Activate a completed Context to generate problem tags and start tracking coverage.
          </p>
        </div>
      </div>
    );
  }

  if (filteredHubs.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-16 text-center">
        <p className="text-sm text-muted-foreground">No hubs match the current filter.</p>
        <Button
          variant="link"
          size="sm"
          className="mt-1.5 text-xs"
          onClick={() => {
            setActiveFilter("all");
            setSearchQuery("");
          }}
        >
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-1.5">
      {filteredHubs.map((hub) => (
        <HubRow key={hub.id} hub={hub} />
      ))}
    </div>
  );
};
